/* AUMI — <bundle-builder>: soma os produtos marcados, mostra o desconto do ritual e adiciona tudo à sacola */
if (!customElements.get('bundle-builder')) {
  const money = (cents) => {
    if (window.AUMI && typeof window.AUMI.formatMoney === 'function') return window.AUMI.formatMoney(cents);
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  };

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('[data-bundle-item]'));
      if (!this.inputs.length) return;
      this.discount = Number(this.dataset.discount) || 0;
      this.min = Number(this.dataset.min) || 2;
      this.el = {
        count: this.querySelector('[data-bundle-count]'),
        subtotal: this.querySelector('[data-bundle-subtotal]'),
        discountRow: this.querySelector('[data-bundle-discount-row]'),
        discountValue: this.querySelector('[data-bundle-discount]'),
        total: this.querySelector('[data-bundle-total]'),
        pix: this.querySelector('[data-bundle-pix]'),
        hint: this.querySelector('[data-bundle-hint]'),
        button: this.querySelector('[data-bundle-add]')
      };
      this.buttonLabel = this.el.button ? this.el.button.textContent.trim() : '';
      this.inputs.forEach((input) => input.addEventListener('change', () => this.update()));
      this.el.button?.addEventListener('click', () => this.addToCart());
      this.update();
    }

    selected() {
      return this.inputs.filter((input) => input.checked && !input.disabled);
    }

    update() {
      const items = this.selected();
      const subtotal = items.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
      const eligible = this.discount > 0 && items.length >= this.min;
      const discount = eligible ? Math.floor((subtotal * this.discount) / 100) : 0;
      const total = subtotal - discount;
      const pixPct = (window.AUMI && window.AUMI.settings && Number(window.AUMI.settings.pixDiscount)) || 0;

      if (this.el.count) this.el.count.textContent = items.length;
      if (this.el.subtotal) this.el.subtotal.textContent = money(subtotal);
      if (this.el.discountRow) this.el.discountRow.hidden = !eligible;
      if (this.el.discountValue) this.el.discountValue.textContent = `–${money(discount)}`;
      if (this.el.total) this.el.total.textContent = money(total);
      if (this.el.pix) this.el.pix.textContent = money(Math.floor((total * (100 - pixPct)) / 100));

      if (this.el.hint && this.discount > 0) {
        const missing = this.min - items.length;
        this.el.hint.textContent = eligible
          ? `Seu ritual ganhou ${this.discount}% off.`
          : `Escolha mais ${missing} ${missing === 1 ? 'produto' : 'produtos'} para ganhar ${this.discount}% off.`;
      }
      if (this.el.button) this.el.button.disabled = items.length === 0;
    }

    async addToCart() {
      const items = this.selected().map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }));
      if (!items.length || !this.el.button) return;
      const button = this.el.button;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      try {
        if (window.AUMI && window.AUMI.cart && typeof window.AUMI.cart.add === 'function') {
          await window.AUMI.cart.add({ items });
        } else {
          const response = await fetch(`${(window.AUMI && window.AUMI.routes && window.AUMI.routes.cartAdd) || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error((await response.json()).description || 'Erro ao adicionar');
          window.location.href = (window.AUMI && window.AUMI.routes && window.AUMI.routes.cart) || '/cart';
        }
      } catch (error) {
        /* o AUMI.cart.add já mostra o toast de erro; aqui só cobrimos o fallback sem global.js */
        const usedGlobal = window.AUMI && window.AUMI.cart && typeof window.AUMI.cart.add === 'function';
        if (!usedGlobal && this.el.hint) {
          this.el.hint.textContent = (error && error.message) || 'Não foi possível adicionar o ritual. Tente novamente.';
        }
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
